import React, { useEffect, useState } from "react";
import Footer from "../../Components/Footer";
import Navbar from "../../Components/Header";
import Pricing from "../../Components/PricingTable";
import SEOServices from "../../Components/SlidingCards";
import blobTopLeft from "../../Images/Framemission.png";
import bgplans from "../../Images/Frame.png";
import graphicservice from "../../Images/Graphics PNG/seo.png";
const words = ["Unique", "High-Quality", "Specialized", "Exclusive"];

const SEO = () => {
  const [currentWord, setCurrentWord] = useState(0);
  const [animate, setAnimate] = useState(false);

  const plans = [
    {
      name: "Basic",
      features: [
        "Website Audit: Comprehensive audit identifying key issues and opportunities.",
        "Keyword Research: Identification of relevant keywords for your business.",
        "On-Page Optimization: Optimization of meta tags, headings, images, and content.",
        "Google Analytics Setup: Setting up and configuring Google Analytics for performance tracking.",
        "Monthly Performance Report: Basic report covering key SEO metrics.",
      ],
    },
    {
      name: "Standard",
      features: [
        "Website Audit: Detailed audit with actionable recommendations.",
        "Keyword Research & Strategy: Extensive keyword research and strategic planning.",
        "On-Page Optimization: Comprehensive on-page SEO, including metadata, content, and technical SEO fixes.",
        "Content Creation: 5 SEO-optimized blog posts per month.",
        "Link Building: Monthly link-building strategy and execution.",
        "Google Analytics & Search Console Setup: Setup and advanced configuration.",
        "Monthly Performance Report: Detailed report with analysis and recommendations.",
        "Guest Blog: Will write 2 guest blogs on DA 60+ sites to increase your website's visibility and traffic.",
      ],
    },
    {
      name: "Premium",
      features: [
        "Comprehensive Website Audit: In-depth audit with a focus on advanced technical SEO issues.",
        "Advanced Keyword Research & Strategy: In-depth research and competitive analysis.",
        "Full On-Page & Technical Optimization: Comprehensive on-page SEO, including schema markup, and mobile optimization.",
        "Content Strategy & Creation: Monthly blog posts, articles, and website content optimization.",
        "Link Building & Outreach: High-quality backlinks and outreach campaigns.",
        "Local SEO: Optimization for local search, including Google My Business.",
        "Monthly Performance & Strategy Report: Extensive reporting with insights and strategic recommendations.",
        "Guest Blog: Will write 5 guest blogs on DA 60+ sites to increase your website's visibility and traffic.",
      ],
    },
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setAnimate(true);

      setTimeout(() => {
        setCurrentWord((prevWord) => (prevWord + 1) % words.length);
        setAnimate(false);
      }, 500);
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className=" md:h-screen md:overflow-y-scroll lg:snap-y lg:snap-mandatory lg:h-screen lg:overflow-y-scroll">
      <div className="lg:snap-start lg:h-screen  md:h-screen">
        <div className="">
          <Navbar color={"bg-teal-950 text-white"} />
        </div>

        {/* Animated Text Section */}
        <div className=" flex flex-col justify-between">
          <div className="max-w-7xl mx-auto px-8 lg:px-8 flex flex-col md:flex-row lg:flex-row gap-8 pb-20 lg:pt-10">
            {/* Left Side: Text Section */}
            <div className="flex flex-col justify-center w-full lg:w-1/2 md:w-1/2 mt-6 md:mt-4 lg:mt-10">
              <h1 className="relative h-12 mb-2 md:mb-4 lg:mb-4">
                <span
                  className={`absolute transition-transform duration-500 ease-in-out  text-2xl md:text-3xl lg:text-4xl font-bold text-teal-500`}
                >
                  {words[currentWord]}
                </span>
              </h1>
              <h2 className="text-3xl md:text-4xl lg:text-6xl font-bold mb-6 text-teal-800">
                Search Engine Optimization (SEO)
              </h2>
              <p className="text-gray-600 mb-8 text-md md:text-lg lg:text-lg">
                Ignite the force of visual storytelling, from bespoke
                illustrations to captivating infographics, our talented artists
                sculpt mesmerizing designs that deeply connect with your
                audience and amplify your brand's message.
              </p>
            
            </div>

            {/* Right Side: Image Section */}
            <div className="hidden md:flex lg:flex flex-col lg:flex-row md:flex-row justify-center items-center lg:justify-end w-full lg:w-1/2 md:w-1/2 mt-10 md:mt-0 lg:mt-0 xl:mt-0">
              <img
                src={graphicservice}
                alt="Illustration Design"
                className="w-[350px] h-[250px] md:w-[450px] md:h-[330px] lg:w-[600px] lg:h-[500px]"
              />
            </div>
          </div>
        </div>
      </div>
      {/* Navbar */}

      {/* Numbered Cards Section */}
      <div
        className="mx-auto lg:snap-start lg:h-screen md:h-screen  p-2 m-auto flex items-center justify-center"
        style={{
          backgroundImage: `url(${blobTopLeft})`,
          backgroundSize: "cover",
          backgroundPosition: "top left",
          backgroundRepeat: "no-repeat",
          backgroundAttachment: "fixed", // Fix background movement
        }}
      >
        {/* <NumberedCards cardsData={cardsData} /> */}
        <SEOServices />
      </div>

      {/* Pricing Section */}
      <div className="snap-start">
        <div
          className="w-full  mx-auto  "
          style={{
            backgroundImage: `url(${bgplans})`,
            backgroundSize: "cover",
            backgroundPosition: "top left",
            backgroundRepeat: "no-repeat",
            backgroundAttachment: "fixed", // Fix background movement
          }}
        >
          <Pricing plans={plans} />
        </div>
      </div>

      {/* Footer */}
      <div className="snap-start">
        <Footer />
      </div>
    </div>
  );
};

export default SEO;
